import { shape, string } from 'prop-types';

import { ExampleColors } from './Category';

export const ArticlePropType = {
	verticalColor: shape({
		primary: string,
		secondary: string,
	}),
	img: shape({
		src: string,
		alt: string,
	}),
	alt: string,
	label: string,
	author: shape({
		name: string,
		username: string,
	}),
	duration: string,
	timePublished: string,
	heading: string,
};

export const examplePost: Post = {
	id: '12345',
	status: 'published',
	img: {
		src: '/assets/images/example.jpg',
		cinematicSrc: '/assets/images/example.jpg',
		alt: 'example image',
	},
	category: { name: 'category', slug: '/' },
	vertical: {
		colors: {
			primary: ExampleColors.gaming,
			secondary: ExampleColors['gaming-secondary'],
		},
	},
	author: {
		name: 'Joe Blogs',
		href: '',
	},
	duration: '2:22',
	timePublished: '0 mins ago',
	heading:
		'Title that spans over several lines but could do a lil more if you wanted',
	href: '/',
	isFeatured: false,
	description: '',
};
